import { Route, Switch } from 'react-router-dom';
import React from 'react';
import TicketView from './scenes/View';

const TicketRouter = ({ history, match }) => {
  return (
    <Switch>
      <Route
        exact
        path={`${match.url}/:id`}
        render={(props) => <TicketView history={history} match={match} {...props} />}
      />
    </Switch>
  );
};

export default TicketRouter;
